const MEMBER_SESSION_KEY = 'rastyle_member_session';

export function getMemberSessionToken() {
  try {
    return sessionStorage.getItem(MEMBER_SESSION_KEY) || '';
  } catch {
    return '';
  }
}

export function rememberMemberSessionToken(token) {
  if (!token) return;
  try {
    sessionStorage.setItem(MEMBER_SESSION_KEY, token);
  } catch {
    // Cookie authentication remains available when storage is disabled.
  }
}

export function clearMemberSessionToken() {
  try {
    sessionStorage.removeItem(MEMBER_SESSION_KEY);
  } catch {
    // Nothing else to clear.
  }
}

export function memberAuthConfig(config = {}) {
  const token = getMemberSessionToken();
  const headers = { ...(config.headers || {}) };
  if (token && !headers.Authorization) headers.Authorization = `Bearer ${token}`;
  return { ...config, withCredentials: true, headers };
}

export { MEMBER_SESSION_KEY };
